import { loadScript, scrollToElement } from "./utils";

let maps = {
    loadScript: async function () {
        return await loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyDMNt8ykDMbtqdOarTG6wDjmAwgDeyUmzw&callback=console.debug&libraries=marker');
    },

    
    activeMarker: -1,
    activeType: null,
    isClicked: false,
    instanceLookup: new Map(),
    currentMap: null,
    config: {
       streetViewControl: false,
       mapTypeControl: false,
       mapId: "30cea62ee751eb35", 
    },

    hoverCallback: "",
    selectMarker: function (marker, selected) {
        maps.toggleActiveMarker(marker.id, true);
    },
    selectMarkerById: function (markerId, selected, shouldMarkAsCurrent) {
        maps.toggleActiveMarker(markerId, true);
    },
   
    //återvinningsplats
    zoomToMarker: function (markerId, lat, lng, level = 12) {
        if (lat && lng) {
            let position = new google.maps.LatLng(lat, lng);
            maps.currentMap.panTo(position);
            google.maps.event.addListenerOnce(maps.currentMap, "idle", function () {
                maps.currentMap.setZoom(level);
            });
        } 
        if (markerId) {
            setTimeout(() => {
                maps.toggleActiveMarker(markerId, true);
            }, 500);

        }
    },

    //avbrottskartan
    setKmlLayers: function (element, layers) {
        var map = maps.instanceLookup.get(element);

        if (!map) {
            return;
        }

        var attributes = { preserveViewport: true };
        if (element && layers) {
            var arr = [];

            var timestamp = new Date();

            layers.forEach(e => {
                var kmlUrl = e + '&' + timestamp.getTime();
                var kmlLayer = new google.maps.KmlLayer(kmlUrl, attributes);
                kmlLayer.setMap(map);
                arr.push(kmlLayer);
            }
            );

            maps.instanceLookup.set(element + '-kml', arr);

        }
    },
    //avbrottskartan
    clearKmlLayers: function (element) {

        var layers = maps.instanceLookup.get(element + '-kml');

        if (layers) {
            layers.forEach(e => e.setMap(null))
        }
    },

    //avbrottskartan
    initStaticMap: async function (elementId, mapConfig) {
        var element = document.getElementById(elementId);

        if (!element) {
            return;
        }

        var config = {
            ...maps.config,
            center: { lat: mapConfig.lat, lng: mapConfig.lng },
            zoom: mapConfig.zoom 
        };

        const { Map } = await google.maps.importLibrary("maps");

        var map = new google.maps.Map(element, config);
        maps.instanceLookup.set(elementId, map)
 
    },
 

    //Återvinningsplatser
    resetActiveIcons: function () {
        maps.activeMarker = -1;
        document.querySelectorAll('.custom-marker.active').forEach(marker => {
            marker.classList.remove("active");
        });
        document.querySelectorAll('.area__link a').forEach(link => {
            link.classList.remove('active');
        });
    },

    hoverType: function (typeName) {
        if (maps.isClicked) return;
        document.querySelectorAll('.custom-marker').forEach(marker => {
            if (!typeName || marker.classList.contains(typeName)) {
                marker.classList.remove("hided");
            } else {
                marker.classList.add("hided");
            }
        });
    },
 
    setActiveType: function (typeName) {
        if (maps.activeType === typeName) {
            maps.activeType = null;
            maps.isClicked = false;

            document.querySelectorAll('.custom-marker').forEach(marker => {
                marker.classList.remove("clicked");
                marker.classList.remove("hided"); 
            });
        }
        else {
            maps.activeType = typeName;
            maps.isClicked = true;

            document.querySelectorAll('.custom-marker').forEach(marker => {
                if (marker.classList.contains(typeName)) {
                    marker.classList.remove("hided");
                    marker.classList.add("clicked");
                } else {
                    marker.classList.add("hided");
                    marker.classList.remove("clicked");
                }
            });
        }
    },

    activeItem: function (currentMarker) {
        maps.resetActiveIcons();
        maps.activeMarker = currentMarker;

        maps.toggleActiveMarker(currentMarker, true);


        if (this.dotNetInstance && this.clickCallback) {
            this.dotNetInstance.invokeMethodAsync(this.clickCallback, currentMarker);
        }
    },

    initDotNetInstance: function (instance, clickCallback, hoverCallback) {
        this.dotNetInstance = instance;
        this.clickCallback = clickCallback;
        this.hoverCallback = hoverCallback;
    },

    //Lediga lägenheter
    //Lediga lokaler
    initMapAppartments: async function (dotNetInstance, places, elementId, clickCallback, hoverCallback, clickToNav = false) {
      document.getElementsByTagName("body")[0].classList.remove('fullscreen');

        if (!places) {
            return;
        }

        var element = document.getElementById(elementId);
        if (!element) {
            console.log('[MAP] ' + elementId + ': element is null!');
            return;
        }
        maps.initDotNetInstance(dotNetInstance, clickCallback, hoverCallback);
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        maps.currentMap = new google.maps.Map(element, maps.config);
        var bounds = new google.maps.LatLngBounds();

        var infoWindow = new google.maps.InfoWindow();
        var infoWindowBottomLeft = document.getElementById("info-window-bottom-left");
        var activeMarker = null;
        places.forEach(function (item, index) {
            if (item.latitude && item.longitude) {

                const latlng = new google.maps.LatLng(item.latitude, item.longitude);
                const customContent = document.createElement("div");
                customContent.classList.add("custom-marker");
                customContent.classList.add("housing");
                customContent.setAttribute("data-id", String(item.objectId));

                const marker = new AdvancedMarkerElement({
                    map: maps.currentMap,
                    position: latlng,
                    content: customContent,
                    title: item.address
                });
                marker.addListener('gmp-click', function () {
                    var apartmentElement = document.getElementById(`apartment-${item.objectId}`);

                    if (apartmentElement) {
                        // Om användaren klickar på samma aktiva element -> avaktivera det
                        if (maps.activeMarker === item.objectId) {
                            maps.toggleActiveMarker(item.objectId, false);
                            maps.activeMarker = null; // Nollställ aktiv markör
                            apartmentElement.classList.remove('active');
                            return;
                        }

                        // Inaktivera alla tidigare aktiva markörer
                        document.querySelectorAll('.apartment-item').forEach(el => el.classList.remove('active'));
                        maps.resetActiveIcons();

                        // Aktivera den nya markören
                        apartmentElement.classList.add('active');
                        maps.activeItem(item.objectId); 
                        var closeButton = apartmentElement.querySelector('.icon-close');
                        if (closeButton) {
                            closeButton.addEventListener('click', function () {
                                apartmentElement.classList.remove('active');
                                maps.toggleActiveMarker(item.objectId, false);
                                maps.activeMarker = null; 
                                if (dotNetInstance && clickCallback) {
                                    dotNetInstance.invokeMethodAsync(clickCallback, null);
                                }
                            }, { once: true }); 
                        }
                    }

                    if (dotNetInstance && clickCallback) {
                        dotNetInstance.invokeMethodAsync(clickCallback, item.objectId);
                    }
                });
                customContent.addEventListener('mouseover', function () {
                    customContent.classList.add("hover");
                    if (dotNetInstance && hoverCallback) {
                        dotNetInstance.invokeMethodAsync(hoverCallback, item.objectId, true);
                    }
                });

                customContent.addEventListener('mouseout', function () {
                    customContent.classList.remove("hover"); 
                    if (dotNetInstance && hoverCallback) {
                        dotNetInstance.invokeMethodAsync(hoverCallback, item.objectId, false);
                    }
                });
                bounds.extend(latlng);
            }
        });

        maps.currentMap.fitBounds(bounds);
    },
 

    //Används vid hover listan bostadsområden
    //Lediga lokaler
    //Används för listan vid kartan på lediga lägenheter
    toggleHoverMarker: function(id, activate) {
        var marker = document.querySelector(`.custom-marker[data-id='${id}']`);

        if (marker) {
            if (activate) {
                marker.classList.add("hover");
            } else {
                marker.classList.remove("hover");
            }
        }
    },
    toggleActiveMarker: function (id, activate) {
        var marker = document.querySelector(`.custom-marker[data-id='${id}']`);
        if (marker) {
            if (activate) {
                marker.classList.add("active");
            } else {
                marker.classList.remove("active");
            }
        }
    },
    //Används för att märka ut bostadsområden på kartan
    initMapMultiple: async function (dotNetInstance, places, hoverCallback) {
     
        if (!places) {
            return;
        }

        if (places.length > 0 && typeof places === "string") {
            places = JSON.parse(places);
        }

        maps.initDotNetInstance(dotNetInstance, "", hoverCallback);
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        const bounds = new google.maps.LatLngBounds();

        maps.currentMap = new google.maps.Map(document.getElementById("neighborhoodMap"), maps.config);
        places.forEach(function (item) {
            if (item.latitud && item.longitud) {
                const latlng = new google.maps.LatLng(item.latitud, item.longitud);
                const customContent = document.createElement("div");
                customContent.classList.add("custom-marker");
                customContent.classList.add("housing");
                customContent.setAttribute("data-id", item.id);

                const marker = new AdvancedMarkerElement({
                    map: maps.currentMap,
                    position: latlng,
                    content: customContent,
                    title: item.title
                });
       
                marker.addListener("gmp-click", () => {
                    if (item.url) {
                        window.location.href = item.url;
                    }
                });
                customContent.addEventListener('mouseover', function () {
                    customContent.classList.add("hover");
                    if (dotNetInstance && hoverCallback) {
                        dotNetInstance.invokeMethodAsync(hoverCallback, item.id, true);
                    }
                });

                customContent.addEventListener('mouseout', function () {
                    customContent.classList.remove("hover");
                    if (dotNetInstance && hoverCallback) {
                        dotNetInstance.invokeMethodAsync(hoverCallback, item.id, false);
                    }
                });
                bounds.extend(latlng); 
            }
        });
        maps.currentMap.fitBounds(bounds, { padding: 50 });
    },

    //återvinningsplatser
    initMapRecycle: async function (dotNetInstance, places, elementId, clickCallback, hoverCallback, clickToNav = false) {
        document.getElementsByTagName("body")[0].classList.remove('fullscreen');
        maps.markers = [];
        maps.initDotNetInstance(dotNetInstance, clickCallback, hoverCallback);

        if (!places) {
            return;
        }
        if (places.length > 0 && typeof (places) === "string") {
            places = JSON.parse(places);
        }

        var element = document.getElementById(elementId);

        if (!element) {
            console.log('[MAP] recycle map: element is null!');
            return;
        }

        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        maps.currentMap = new google.maps.Map(element, maps.config);

        var bounds = new google.maps.LatLngBounds();

        places.forEach(function (item) {
            if (item.latitud && item.longitud) {
                const latlng = new google.maps.LatLng(item.latitud, item.longitud);
                const customContent = document.createElement("div");
                customContent.classList.add("custom-marker");
                customContent.classList.add(item.recyclePlaceType);
                customContent.setAttribute("data-id", item.id);
                var zindex = item.recyclePlaceType == "station" ? 10 : 1;
                const marker = new AdvancedMarkerElement({
                    map: maps.currentMap,
                    position: latlng,
                    content: customContent,
                    title: item.name,
                    zIndex: zindex
                });

                //återvinningsplatser-alla
                const placeList = document.querySelector('.place-list');

                if (placeList) {
                    placeList.addEventListener("mouseleave", function () {
                        maps.isClicked = false;
                    });
                }
                marker.addListener('gmp-click', function () {                  
                   var currentMarker = item.id; 
                    //återvinningsplatser
                    maps.activeItem(currentMarker);
                    elementscroll.overIdScroll("RecyclingGuideMap", 150, true);
                });


                customContent.addEventListener('mouseover', function () {
                    customContent.classList.add("hover"); 
                    if (hoverCallback) {
                        dotNetInstance.invokeMethodAsync(hoverCallback, item.id, true);
                    }
                });

                customContent.addEventListener('mouseout', function () {
                    customContent.classList.remove("hover");
                    if (hoverCallback) {
                        dotNetInstance.invokeMethodAsync(hoverCallback, item.id, false);
                    }
                });

                bounds.extend(latlng);
            }
        });
     
        maps.currentMap.fitBounds(bounds);
    }
};

export { maps };
